import { render } from "./EventsListModal.vue?vue&type=template&id=3814958e&ts=true"
import script from "./EventsListModal.vue?vue&type=script&lang=ts"
export * from "./EventsListModal.vue?vue&type=script&lang=ts"

import "./EventsListModal.vue?vue&type=style&index=0&id=3814958e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__